/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */

export const STEP_STATUS = {
  CONTINUE: 'continue',
  STOP: 'stop',
  RESTART: 'restart',
}

/**
 * 플로우를 실행합니다.
 *
 * ### 스텝 실행 관련
 * - 각 스텝은 순차적으로 실행되며, 각 스텝의 결과에 따라 다음 스텝을 결정합니다.
 * - 현재 스텝의 상태(status)에 따라 다음 스텝을 결정합니다.
 *   - CONTINUE: 다음 스텝으로 진행합니다(기본값).
 *   - STOP: 플로우를 종료합니다.
 *   - RESTART: 플로우를 처음부터 다시 실행합니다.
 *
 * ### 각 스텝별 파라미터 및 반환값 관련
 * - 각 스텝은 context 객체를 인자로 받으며, context 객체에는 이전 스텝에서 반환된 값이 포함됩니다.
 * - 각 스텝은 status와 payload를 반환하여, context 객체에 자동으로 병합되어 다음 스텝으로 전달할 수 있습니다.
 *   - 코드 예시
 *     ```
 *     const step = async (context) => {
 *       const { logger, payload } = context
 *      // ... do something
 *      return {
 *        status: STEP_STATUS.CONTINUE,
 *       payload: {
 *         // ... 다음 스텝으로 전달할 데이터 (payload는 context에 자동으로 병합됩니다.)
 *        },
 *      }
 *     }
 *     ```
 *
 * @param {*} deps
 * @param {Array} deps.steps - 각 스텝의 이름을 담은 배열로 순차적으로 실행됩니다.
 * @param {Object} deps.context - 각 스텝에서 사용되는 context 객체입니다.
 * @returns
 */
export const runFlow = async ({ steps, context }) => {
  const { logger } = context
  let stepIdx = 0

  while (stepIdx < steps.length) {
    logger.addBreadcrumb({
      type: 'info',
      category: 'sso-for-web-game',
      message: `[signInForWeb] Step ${stepIdx + 1} - ${steps[stepIdx].name}`,
      level: 'info',
    })

    const { status, payload } = await steps[stepIdx](context) ?? { status: STEP_STATUS.CONTINUE, payload: {} }
    if (status === STEP_STATUS.STOP) {
      logger.addBreadcrumb({
        type: 'error',
        category: 'sso-for-web-game',
        message: '[signInForWeb] Flow stopped',
        level: 'error',
      })
      break
    }
    if (status === STEP_STATUS.RESTART) {
      logger.addBreadcrumb({
        type: 'info',
        category: 'sso-for-web-game',
        message: '[signInForWeb] Flow restartes from the beginning',
        level: 'info',
      })
      Object.assign(context, payload)
      stepIdx = 0
      continue
    }

    Object.assign(context, payload)
    stepIdx += 1
  }
  return context
}
